import { siteInfo } from "@/mocks/site";

export default function StatsBand() {
  return (
    <section aria-label="平台数据概览" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-content grid-cols-2 gap-6 px-4 py-10 md:px-6 md:py-12 lg:grid-cols-4">
        {siteInfo.stats.map((stat, index) => (
          <div
            key={stat.label}
            className={`flex flex-col gap-1 ${index > 0 ? "lg:border-l lg:border-background-300 lg:pl-6" : ""}`}
          >
            <span className="font-heading text-3xl font-black text-primary-600 md:text-4xl">
              {stat.value}
              <span className="ml-1 text-base font-bold text-foreground-500">{stat.unit}</span>
            </span>
            <span className="text-sm text-foreground-600">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}